<template>
  <div class="row">
    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="CSEE:"
        label-class="text-gray font-weight-light label-title"
        :value="csee"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Municipio:"
        label-class="text-gray font-weight-light label-title"
        :value="municipality"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Proveedor:"
        label-class="text-gray font-weight-light label-title"
        :value="provider"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Lugar de Servicio:"
        label-class="text-gray font-weight-light label-title"
        :value="serviceLocation"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Especialista:"
        label-class="text-gray font-weight-light label-title"
        :value="specialist"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Número de Cita:"
        label-class="text-gray font-weight-light label-title"
        :value="appointmentNumber"
      />
    </div>

    <div class="col-12 col-md-3 mb-3">
      <CustomInputDisplay
        label="Fecha de Cita:"
        label-class="text-gray font-weight-light label-title"
        :value="appointmentDate"
      />
    </div>

    <div class="col-12 mb-3">
      <CustomInputDisplay
        label="Comentario de la cita recomendada:"
        label-class="text-gray font-weight-light label-title"
        :value="comment"
      />
    </div>
  </div>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import moment from 'moment';

export default {
  name: 'AppointmentInformation',
  components: {
    CustomInputDisplay,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    model() {
      return this.value;
    },
    csee() {
      return this.model?.csee || '-';
    },
    municipality() {
      return this.model?.municipality || '-';
    },
    provider() {
      return this.model?.provider || '-';
    },
    serviceLocation() {
      return this.model?.serviceLocation || '-';
    },
    specialist() {
      return this.model?.specialist || '-';
    },
    appointmentNumber() {
      return this.model?.appointmentNumber || '-';
    },
    appointmentDate() {
      if (this.model && this.model.appointmentDate)
        return moment(this.model.appointmentDate).format('DD/MMM/YYYY');

      return '-';
    },
    comment() {
      return this.model?.comment || '-';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .label-title {
  font-size: 0.875rem !important;
}
</style>
